(function () {
  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format || (window.general && window.general.currency));
    }

    return formatMoneyFromPattern(cents, format);
  }

  function formatMoneyFromPattern(cents, format) {
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "{{amount}}";
    var match = formatString.match(placeholderRegex);
    var value;

    if (!match) {
      return (Number(cents || 0) / 100).toFixed(2);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      var amount = Number(number || 0);
      var parts;
      var dollars;
      var centsValue;

      precision = typeof precision === "undefined" ? 2 : precision;
      thousands = typeof thousands === "undefined" ? "," : thousands;
      decimal = typeof decimal === "undefined" ? "." : decimal;

      if (isNaN(amount) || amount === null) {
        amount = 0;
      }

      parts = (amount / 100).toFixed(precision).split(".");
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      centsValue = parts[1] ? decimal + parts[1] : "";

      return dollars + centsValue;
    }

    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function parseData(root) {
    var script = root.querySelector("[data-bundle-config-data]");
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error("bundle-configurator data error", error);
      return null;
    }
  }

  function byId(items, id) {
    return items.find(function (item) {
      return String(item.id) === String(id);
    }) || null;
  }

  function getVariant(product, variantId) {
    if (!product) {
      return null;
    }

    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  function getDefaultVariant(product) {
    if (!product) {
      return null;
    }

    return getVariant(product, product.defaultVariantId) || product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0] || null;
  }

  function getVariantForSize(product, optionIndex, optionValue) {
    if (!product) {
      return null;
    }

    return product.variants.find(function (variant) {
      return variant.available && variant.options[optionIndex] === optionValue;
    }) || product.variants.find(function (variant) {
      return variant.options[optionIndex] === optionValue;
    }) || null;
  }

  function hasFastDispatch(variant) {
    return !!(variant && variant.available && variant.shippingTime && String(variant.shippingTime).indexOf("24") !== -1);
  }

  function renderFastDispatchIndicator(text) {
    return '<span class="variant-dispatch-indicator size-fast-dispatch size-shipping-note">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" aria-hidden="true" focusable="false">' +
        '<path d="M5.867.5 1.48 6.03h2.746L3.8 11.5l4.72-5.86H5.637z"></path>' +
      "</svg>" +
      "<span>" + text + "</span>" +
    "</span>";
  }

  function productHasFastDispatch(product) {
    return !!(product && product.variants && product.variants.some(function (variant) {
      return hasFastDispatch(variant);
    }));
  }

  function normalizeImageUrl(url) {
    if (!url) {
      return "";
    }

    if (String(url).indexOf("//") === 0) {
      return "https:" + url;
    }

    return url;
  }

  function getSizeOptionIndex(product) {
    if (!product || !product.options || !product.options.length) {
      return 0;
    }

    var sizeNames = ["size", "méret"];
    var matchIndex = product.options.findIndex(function (name) {
      return sizeNames.indexOf(String(name || "").toLowerCase()) !== -1;
    });

    return matchIndex === -1 ? 0 : matchIndex;
  }

  function getSizeValues(product) {
    if (!product) {
      return [];
    }

    var optionIndex = getSizeOptionIndex(product);
    var seen = {};

    return product.variants.reduce(function (acc, variant) {
      var value = variant.options[optionIndex] || variant.title;

      if (!seen[value]) {
        seen[value] = true;
        acc.push({
          value: value,
          available: product.variants.some(function (candidate) {
            return candidate.available && candidate.options[optionIndex] === value;
          })
        });
      }

      return acc;
    }, []);
  }

  function sortByMatchingColor(products, anchorProduct) {
    if (!anchorProduct || !anchorProduct.color) {
      return products.slice();
    }

    var anchorColor = String(anchorProduct.color || "").trim().toLowerCase();
    var sorted = products.slice();
    var matchIndex = sorted.findIndex(function (product) {
      return product.color && String(product.color).trim().toLowerCase() === anchorColor;
    });

    if (matchIndex > 0) {
      sorted.unshift(sorted.splice(matchIndex, 1)[0]);
    }

    return sorted;
  }

  function normalizePairText(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\bgray\b/g, "grey")
      .trim();
  }

  function getPairTokens(product) {
    var stopWords = {
      essentials: true,
      fear: true,
      god: true,
      of: true,
      the: true,
      and: true,
      x: true,
      hoodie: true,
      hoodies: true,
      sweatpant: true,
      sweatpants: true,
      pant: true,
      pants: true,
      jogger: true,
      joggers: true,
      t: true,
      tee: true,
      tees: true,
      tshirt: true,
      tshirts: true,
      shirt: true,
      shirts: true,
      fleece: true,
      jersey: true,
      short: true,
      shorts: true
    };
    var seen = {};
    var text = normalizePairText(product && (product.title || product.label || product.color || product.handle));

    return text.split(" ").filter(function (token) {
      if (!token || stopWords[token] || seen[token]) {
        return false;
      }

      seen[token] = true;
      return true;
    });
  }

  function getPairKey(product) {
    return getPairTokens(product).join(" ");
  }

  function isSeasonPairToken(token) {
    return /^(fw|ss)\d{2,4}$/.test(token);
  }

  function isOptionalPairModifierToken(token) {
    return token === "relaxed";
  }

  function getComparablePairTokens(product) {
    return getPairTokens(product).filter(function (token) {
      return !isSeasonPairToken(token) && !isOptionalPairModifierToken(token);
    });
  }

  function isCompatiblePairProduct(anchorProduct, candidateProduct) {
    var anchorTokens = getComparablePairTokens(anchorProduct);
    var candidateTokens = getComparablePairTokens(candidateProduct);
    var anchorMap = {};
    var candidateMap = {};
    var compatible = true;

    if (!anchorTokens.length || !candidateTokens.length) {
      return false;
    }

    anchorTokens.forEach(function (token) {
      anchorMap[token] = true;
    });

    candidateTokens.forEach(function (token) {
      candidateMap[token] = true;
    });

    anchorTokens.forEach(function (token) {
      if (!candidateMap[token]) {
        compatible = false;
      }
    });

    candidateTokens.forEach(function (token) {
      if (!anchorMap[token] && !isOptionalPairModifierToken(token)) {
        compatible = false;
      }
    });

    return compatible;
  }

  function tokenWeight(token) {
    if (/^\d{2,4}$/.test(token) || token === "nba" || token === "state") {
      return 6;
    }

    if (isSeasonPairToken(token)) {
      return 1;
    }

    return 3;
  }

  var PAIR_MATCH_MIN_SCORE = 18;

  function scorePairMatch(anchorProduct, candidateProduct) {
    var anchorTokens = getPairTokens(anchorProduct);
    var candidateTokens = getPairTokens(candidateProduct);
    var candidateMap = {};
    var score = 0;
    var meaningfulMatches = 0;

    if (!anchorTokens.length || !candidateTokens.length) {
      return 0;
    }

    candidateTokens.forEach(function (token) {
      candidateMap[token] = true;
    });

    anchorTokens.forEach(function (token) {
      var weight = tokenWeight(token);
      if (candidateMap[token]) {
        score += weight * 8;
        meaningfulMatches += 1;
      } else {
        score -= weight * 5;
      }
    });

    candidateTokens.forEach(function (token) {
      if (anchorTokens.indexOf(token) === -1) {
        score -= tokenWeight(token);
      }
    });

    if (getPairKey(anchorProduct) === getPairKey(candidateProduct)) {
      score += 60;
    }

    if (meaningfulMatches < 1) {
      return 0;
    }

    return score;
  }

  function findMatchingPairProduct(anchorProduct, candidates) {
    var bestProduct = null;
    var bestScore = 0;

    if (!anchorProduct || !candidates || !candidates.length) {
      return null;
    }

    candidates.forEach(function (candidate) {
      var score = scorePairMatch(anchorProduct, candidate);

      if (score >= PAIR_MATCH_MIN_SCORE && isCompatiblePairProduct(anchorProduct, candidate) && score > bestScore) {
        bestScore = score;
        bestProduct = candidate;
      }
    });

    return bestScore >= PAIR_MATCH_MIN_SCORE ? bestProduct : null;
  }

  function sortByMatchingPair(products, anchorProduct) {
    var sorted = sortByMatchingColor(products, anchorProduct);
    var match = findMatchingPairProduct(anchorProduct, sorted);
    var matchIndex;

    if (!match) {
      return sorted;
    }

    matchIndex = sorted.findIndex(function (product) {
      return String(product.id) === String(match.id);
    });

    if (matchIndex > 0) {
      sorted.unshift(sorted.splice(matchIndex, 1)[0]);
    }

    return sorted;
  }

  function sortByMatchingPairGroup(products, anchorProduct) {
    var sorted = sortByMatchingColor(products, anchorProduct);
    var scoredProducts = [];
    var matchedIds = {};

    if (!anchorProduct || !sorted.length) {
      return sorted;
    }

    sorted.forEach(function (candidateProduct, index) {
      var score = scorePairMatch(anchorProduct, candidateProduct);

      if (score >= PAIR_MATCH_MIN_SCORE && isCompatiblePairProduct(anchorProduct, candidateProduct)) {
        scoredProducts.push({
          product: candidateProduct,
          index: index,
          score: score
        });
      }
    });

    if (!scoredProducts.length) {
      return sorted;
    }

    scoredProducts.sort(function (a, b) {
      if (b.score !== a.score) {
        return b.score - a.score;
      }

      return a.index - b.index;
    });

    scoredProducts.forEach(function (item) {
      matchedIds[String(item.product.id)] = true;
    });

    return scoredProducts.map(function (item) {
      return item.product;
    }).concat(sorted.filter(function (product) {
      return !matchedIds[String(product.id)];
    }));
  }

  function comparePairProducts(firstProduct, secondProduct) {
    var firstKey = getPairKey(firstProduct);
    var secondKey = getPairKey(secondProduct);
    var firstLabel = String(firstProduct && (firstProduct.label || firstProduct.title) || "");
    var secondLabel = String(secondProduct && (secondProduct.label || secondProduct.title) || "");

    if (firstKey !== secondKey) {
      return firstKey.localeCompare(secondKey);
    }

    return firstLabel.localeCompare(secondLabel);
  }

  function sortByPairSequence(products, anchorProducts) {
    if (!products || !products.length) {
      return [];
    }

    var unmatched = products.slice();
    var matched = [];

    if (!anchorProducts || !anchorProducts.length) {
      return products.slice();
    }

    anchorProducts.forEach(function (anchorProduct) {
      var scoredProducts = [];

      unmatched.forEach(function (candidateProduct, index) {
        var score = scorePairMatch(anchorProduct, candidateProduct);

        if (score >= PAIR_MATCH_MIN_SCORE && isCompatiblePairProduct(anchorProduct, candidateProduct)) {
          scoredProducts.push({
            product: candidateProduct,
            index: index,
            score: score
          });
        }
      });

      if (!scoredProducts.length) {
        return;
      }

      scoredProducts.sort(function (a, b) {
        if (b.score !== a.score) {
          return b.score - a.score;
        }

        return a.index - b.index;
      });

      scoredProducts.forEach(function (item) {
        matched.push(item.product);
      });

      scoredProducts.slice().sort(function (a, b) {
        return b.index - a.index;
      }).forEach(function (item) {
        unmatched.splice(item.index, 1);
      });
    });

    return matched.concat(unmatched.slice().sort(comparePairProducts));
  }

  function sortMainProductsByPairAvailability(mainProducts, addonProducts) {
    var paired = [];
    var unmatched = [];

    if (!mainProducts || !mainProducts.length) {
      return [];
    }

    if (!addonProducts || !addonProducts.length) {
      return mainProducts.slice();
    }

    mainProducts.forEach(function (mainProduct) {
      if (findMatchingPairProduct(mainProduct, addonProducts)) {
        paired.push(mainProduct);
      } else {
        unmatched.push(mainProduct);
      }
    });

    return paired.concat(unmatched);
  }

  function enhanceHorizontalScroll(row) {
    var selector;
    var previousButton;
    var nextButton;
    var arrowVisibilityTimer = null;
    var programmaticScrollTimer = null;
    var isProgrammaticScroll = false;

    if (!row || row.dataset.bundleDragScroll === "true") {
      return;
    }

    row.dataset.bundleDragScroll = "true";
    selector = row.closest(".bundle-configurator__selector");
    previousButton = selector ? selector.querySelector("[data-bundle-selector-prev]") : null;
    nextButton = selector ? selector.querySelector("[data-bundle-selector-next]") : null;

    function getScrollStep() {
      var firstCard = row.querySelector(".bundle-configurator__product-card");
      var styles = window.getComputedStyle(row);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      var cardWidth = firstCard ? firstCard.getBoundingClientRect().width : 140;

      return Math.max((cardWidth + gap) * 3, row.clientWidth * 0.7);
    }

    function setArrowVisuallyHidden(button, hidden) {
      if (!button || button.classList.contains("is-visually-hidden") === hidden) {
        return;
      }

      button.classList.toggle("is-visually-hidden", hidden);
    }

    function updateArrowVisibility() {
      var maxScrollLeft = Math.max(row.scrollWidth - row.clientWidth, 0);

      setArrowVisuallyHidden(previousButton, maxScrollLeft <= 2 || row.scrollLeft <= 2);
      setArrowVisuallyHidden(nextButton, maxScrollLeft <= 2 || row.scrollLeft >= maxScrollLeft - 2);
    }

    function scheduleArrowVisibilityUpdate(delay) {
      if (isProgrammaticScroll) {
        return;
      }

      window.clearTimeout(arrowVisibilityTimer);
      arrowVisibilityTimer = window.setTimeout(updateArrowVisibility, delay || 220);
    }

    function scrollByDirection(direction) {
      var maxScrollLeft = Math.max(row.scrollWidth - row.clientWidth, 0);
      var targetScrollLeft = Math.max(0, Math.min(row.scrollLeft + (getScrollStep() * direction), maxScrollLeft));

      if (maxScrollLeft <= 2) {
        return;
      }

      if (direction < 0 && row.scrollLeft <= 2) {
        targetScrollLeft = maxScrollLeft;
      } else if (direction > 0 && row.scrollLeft >= maxScrollLeft - 2) {
        targetScrollLeft = 0;
      }

      isProgrammaticScroll = true;
      row.scrollTo({
        left: targetScrollLeft,
        behavior: "smooth"
      });

      window.clearTimeout(programmaticScrollTimer);
      programmaticScrollTimer = window.setTimeout(function () {
        isProgrammaticScroll = false;
        updateArrowVisibility();
      }, 560);
    }

    if (previousButton) {
      previousButton.addEventListener("mousedown", function (event) {
        event.preventDefault();
      });
      previousButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        previousButton.blur();
        scrollByDirection(-1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener("mousedown", function (event) {
        event.preventDefault();
      });
      nextButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        nextButton.blur();
        scrollByDirection(1);
      });
    }

    row.addEventListener("scroll", function () {
      scheduleArrowVisibilityUpdate(320);
    }, { passive: true });

    row.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });

    updateArrowVisibility();
    window.setTimeout(updateArrowVisibility, 160);
  }

	  function money(cents, data) {
	    return formatMoney(cents, data.currencyFormat);
	  }
	
	  function parseCurrencyRates(value) {
	    if (value && typeof value === "object") {
	      return value;
	    }

	    return String(value || "").split(/\r?\n/).reduce(function (rates, line) {
	      var cleanLine = line.split("#")[0].trim();
	      var parts;
	      var code;
	      var rate;

	      if (!cleanLine) {
	        return rates;
	      }

	      parts = cleanLine.split(/[=:]/);
	      if (parts.length < 2) {
	        return rates;
	      }

	      code = String(parts[0] || "").trim().toUpperCase();
	      rate = Number(String(parts.slice(1).join(":") || "").trim().replace(",", "."));

	      if (/^[A-Z]{3}$/.test(code) && rate > 0) {
	        rates[code] = rate;
	      }

	      return rates;
	    }, {});
	  }

	  function getCurrencyRate(data) {
	    var rates = parseCurrencyRates(data && (data.currencyRatesText || data.currencyRates));
	    var currencyCode = String(data && data.currencyCode || "").toUpperCase();
	    var baseCurrencyCode = String(data && data.baseCurrencyCode || "EUR").toUpperCase();

	    if (!currencyCode || currencyCode === baseCurrencyCode) {
	      return 1;
	    }

	    return Number(rates[currencyCode] || 1);
	  }

	  function convertBaseDiscount(discountPerPiece, data) {
	    return Math.round(Number(discountPerPiece || 0) * getCurrencyRate(data));
	  }

	  function getDiscountedUnitPrice(variant, discountPerPiece, data) {
	    return Math.max(0, Number(variant && variant.price || 0) - convertBaseDiscount(discountPerPiece, data));
	  }
	
	  function createPriceMeta(variants, quantity, discountPerPiece, data) {
	    var priceTotal = 0;
	    var compareTotal = 0;
	    var hasCompare = false;

    variants.forEach(function (variant) {
      if (!variant) {
        return;
      }

	      var discountedUnitPrice = getDiscountedUnitPrice(variant, discountPerPiece, data);
	      priceTotal += discountedUnitPrice;

      if (Number(variant.compareAtPrice || 0) > discountedUnitPrice) {
        compareTotal += Number(variant.compareAtPrice || 0);
        hasCompare = true;
      }
    });

    priceTotal = priceTotal * quantity;
    compareTotal = compareTotal * quantity;

    return {
      total: priceTotal,
      compareTotal: hasCompare && compareTotal > priceTotal ? compareTotal : 0,
      saving: hasCompare && compareTotal > priceTotal ? compareTotal - priceTotal : 0
    };
  }

	  function createPriceMetaFromEntries(entries, discountPerPiece, data) {
	    var priceTotal = 0;
	    var compareTotal = 0;
	    var hasCompare = false;

    entries.forEach(function (entry) {
      if (!entry || !entry.variant || !entry.quantity) {
        return;
      }

	      var quantity = Number(entry.quantity || 0);
	      var variant = entry.variant;
	      var discountedUnitPrice = getDiscountedUnitPrice(variant, discountPerPiece, data);
      priceTotal += discountedUnitPrice * quantity;

      if (Number(variant.compareAtPrice || 0) > discountedUnitPrice) {
        compareTotal += Number(variant.compareAtPrice || 0) * quantity;
        hasCompare = true;
      }
    });

    return {
      total: priceTotal,
      compareTotal: hasCompare && compareTotal > priceTotal ? compareTotal : 0,
      saving: hasCompare && compareTotal > priceTotal ? compareTotal - priceTotal : 0
    };
  }

  function createPriceMetaFromRoleEntries(entries, data) {
    var priceTotal = 0;
    var compareTotal = 0;
    var hasCompare = false;

    entries.forEach(function (entry) {
      if (!entry || !entry.variant || !entry.quantity) {
        return;
      }

      var quantity = Number(entry.quantity || 0);
      var variant = entry.variant;
      var discountedUnitPrice = getDiscountedUnitPrice(variant, Number(entry.discountPerPiece || 0), data);
      priceTotal += discountedUnitPrice * quantity;

      if (Number(variant.compareAtPrice || 0) > discountedUnitPrice) {
        compareTotal += Number(variant.compareAtPrice || 0) * quantity;
        hasCompare = true;
      }
    });

    return {
      total: priceTotal,
      compareTotal: hasCompare && compareTotal > priceTotal ? compareTotal : 0,
      saving: hasCompare && compareTotal > priceTotal ? compareTotal - priceTotal : 0
    };
  }

  function initConfigurator(root) {
    if (root.dataset.bundleConfiguratorInitialized === "true") {
      return;
    }

    var data = parseData(root);
    if (!data) {
      return;
    }

    root.dataset.bundleConfiguratorInitialized = "true";

    var selectors = {
      quantityGrid: root.querySelector("[data-bundle-quantity-grid]"),
      setArea: root.querySelector("[data-bundle-set-area]"),
      mainSelector: root.querySelector('[data-bundle-selector="main"]'),
      primarySelector: root.querySelector('[data-bundle-selector="primary"]'),
      secondarySelector: root.querySelector('[data-bundle-selector="secondary"]'),
      mainSizes: root.querySelector('[data-bundle-sizes="main"]'),
      primarySizes: root.querySelector('[data-bundle-sizes="primary"]'),
      secondarySizes: root.querySelector('[data-bundle-sizes="secondary"]'),
      mainMeta: root.querySelector('[data-bundle-step-meta="main"]'),
      primaryMeta: root.querySelector('[data-bundle-step-meta="primary"]'),
      secondaryMeta: root.querySelector('[data-bundle-step-meta="secondary"]'),
      primarySection: root.querySelector("[data-bundle-primary-section]"),
      secondarySection: root.querySelector("[data-bundle-secondary-section]"),
      upsell: root.querySelector("[data-bundle-upsell]"),
      submit: root.querySelector("[data-bundle-submit]")
    };

    var state = {
      tierId: data.config.quantityTiers[0] ? data.config.quantityTiers[0].id : null,
      mode: "quantity",
      selectedMainProductId: data.productId,
      selectedMainVariantId: null,
      selectedMainVariantQuantities: {},
      selectedPrimaryProductId: null,
      selectedPrimaryVariantId: null,
      selectedSecondaryProductId: null,
      selectedSecondaryVariantId: null,
      secondaryAddonExpanded: false,
      expandedSelectors: {
        main: false,
        primary: false,
        secondary: false
      },
      loading: false
    };

    function getTier() {
      return data.config.quantityTiers.find(function (tier) {
        return tier.id === state.tierId;
      }) || data.config.quantityTiers[0];
    }

    function getSingleQuantityTier() {
      return data.config.quantityTiers.find(function (tier) {
        return Number(tier.qty || 0) === 1;
      }) || data.config.quantityTiers[0] || null;
    }

    function getQuantityDiscountPerPiece(tier) {
      return Number(tier && tier.discountPerPiece || 0);
    }

    function getTierByQuantity(quantity) {
      return data.config.quantityTiers.find(function (tier) {
        return Number(tier.qty || 0) === Number(quantity || 0);
      }) || null;
    }

    function getSetDiscountPerPiece(quantity) {
      if (quantity <= 1) {
        return Number(data.config.setDiscountPerPiece || 0);
      }

      if (quantity === 2) {
        var tierTwo = data.config.quantityTiers.find(function (tier) {
          return Number(tier.qty || 0) === 2;
        });
        return getQuantityDiscountPerPiece(tierTwo);
      }

      var tierThree = data.config.quantityTiers.find(function (tier) {
        return Number(tier.qty || 0) >= 3;
      });
      return getQuantityDiscountPerPiece(tierThree);
    }

    function getCrossAddonDiscountPerPiece(selectedRoleCount) {
      if (selectedRoleCount <= 2) {
        return Number(data.config.setDiscountPerPiece || 0);
      }

      if (selectedRoleCount <= 5) {
        var tierTwo = data.config.quantityTiers.find(function (tier) {
          return Number(tier.qty || 0) === 2;
        });
        return getQuantityDiscountPerPiece(tierTwo);
      }

      var tierThree = data.config.quantityTiers.find(function (tier) {
        return Number(tier.qty || 0) >= 3;
      });
      return getQuantityDiscountPerPiece(tierThree);
    }

    var fallbackDiscountProfiles = {
      winter: {
        setDiscountPerPiece: 650,
        tier2DiscountPerPiece: 1000,
        tier3DiscountPerPiece: 1400
      },
      summer: {
        setDiscountPerPiece: 2500,
        tier2DiscountPerPiece: 2500,
        tier3DiscountPerPiece: 3000
      }
    };

    function normalizeDiscountCents(value, fallbackValue) {
      var amount = Number(value);

      if (Number.isFinite(amount) && amount >= 0) {
        return amount;
      }

      return Number(fallbackValue || 0);
    }

    function getProductDiscountGroupKey(product) {
      var text = normalizePairText([
        product && product.title,
        product && product.label,
        product && product.handle
      ].join(" "));

      if (/\b(t|tee|tees|tshirt|tshirts|shirt|shirts|short|shorts)\b/.test(text)) {
        return "summer";
      }

      if (/\b(hoodie|hoodies|sweatpant|sweatpants|pant|pants|jogger|joggers)\b/.test(text)) {
        return "winter";
      }

      return null;
    }

    function getCurrentDiscountGroupKey() {
      return getProductDiscountGroupKey(getSelectedProduct("main")) ||
        getProductDiscountGroupKey(data.products.main && data.products.main[0]) ||
        (String(data.config.bundleKey || "").toLowerCase().indexOf("tee") !== -1 ? "summer" : "winter");
    }

    function getConfiguredCurrentDiscountProfile() {
      var tierTwo = data.config.quantityTiers.find(function (tier) {
        return Number(tier.qty || 0) === 2;
      });
      var tierThree = data.config.quantityTiers.find(function (tier) {
        return Number(tier.qty || 0) >= 3;
      });

      return {
        setDiscountPerPiece: normalizeDiscountCents(data.config.setDiscountPerPiece, 0),
        tier2DiscountPerPiece: normalizeDiscountCents(tierTwo && tierTwo.discountPerPiece, 0),
        tier3DiscountPerPiece: normalizeDiscountCents(tierThree && tierThree.discountPerPiece, 0)
      };
    }

    function getDiscountProfile(groupKey) {
      var fallbackProfile = fallbackDiscountProfiles[groupKey] || fallbackDiscountProfiles.winter;
      var profile = {
        setDiscountPerPiece: fallbackProfile.setDiscountPerPiece,
        tier2DiscountPerPiece: fallbackProfile.tier2DiscountPerPiece,
        tier3DiscountPerPiece: fallbackProfile.tier3DiscountPerPiece
      };
      var configuredProfiles = data.config.discountProfiles || {};
      var configuredProfile = configuredProfiles[groupKey];

      if (configuredProfile) {
        profile.setDiscountPerPiece = normalizeDiscountCents(configuredProfile.setDiscountPerPiece, profile.setDiscountPerPiece);
        profile.tier2DiscountPerPiece = normalizeDiscountCents(configuredProfile.tier2DiscountPerPiece, profile.tier2DiscountPerPiece);
        profile.tier3DiscountPerPiece = normalizeDiscountCents(configuredProfile.tier3DiscountPerPiece, profile.tier3DiscountPerPiece);
      }

      if (groupKey === getCurrentDiscountGroupKey()) {
        profile = getConfiguredCurrentDiscountProfile();
      }

      return profile;
    }

    function resolveCrossDiscountFromProfile(profile, totalEligibleQuantity) {
      var totalQuantity = Number(totalEligibleQuantity || 0);

      if (totalQuantity >= 6 && profile.tier3DiscountPerPiece > 0) {
        return profile.tier3DiscountPerPiece;
      }

      if (totalQuantity >= 3 && profile.tier2DiscountPerPiece > 0) {
        return profile.tier2DiscountPerPiece;
      }

      if (totalQuantity >= 2 && profile.setDiscountPerPiece > 0) {
        return profile.setDiscountPerPiece;
      }

      return 0;
    }

    function getCurrentGroupCrossDiscountPerPiece(totalEligibleQuantity) {
      return resolveCrossDiscountFromProfile(getDiscountProfile(getCurrentDiscountGroupKey()), totalEligibleQuantity);
    }

    function getProductCrossDiscountPerPiece(product, totalEligibleQuantity) {
      var groupKey = getProductDiscountGroupKey(product) || getCurrentDiscountGroupKey();
      return resolveCrossDiscountFromProfile(getDiscountProfile(groupKey), totalEligibleQuantity);
    }

    function getSelectedProduct(role) {
      if (role === "main") {
        return byId(data.products.main, state.selectedMainProductId);
      }

      if (role === "primary") {
        return byId(data.products.primaryAddon, state.selectedPrimaryProductId);
      }

      return byId(data.products.secondaryAddon, state.selectedSecondaryProductId);
    }

    function getSelectedVariant(role) {
      if (role === "main") {
        return getVariant(getSelectedProduct("main"), state.selectedMainVariantId);
      }

      if (role === "primary") {
        return getVariant(getSelectedProduct("primary"), state.selectedPrimaryVariantId);
      }

      return getVariant(getSelectedProduct("secondary"), state.selectedSecondaryVariantId);
    }

    function getPreviewVariant(role) {
      var product = getSelectedProduct(role);

      if (!product) {
        if (role === "main") {
          product = data.products.main[0] || null;
        } else if (role === "primary") {
          product = getSortedProducts("primary")[0] || null;
        } else {
          product = getSortedProducts("secondary")[0] || null;
        }
      }

      return getSelectedVariant(role) || getDefaultVariant(product);
    }

    function getSortedProducts(role) {
      var items;

      if (role === "main") {
        items = data.products.main;
      } else if (role === "primary") {
        items = data.products.primaryAddon;
      } else {
        items = data.products.secondaryAddon;
      }

      if (role === "main") {
        var ordered = items.slice();
        if (state.secondaryAddonExpanded && data.config.secondaryAddonEnabled) {
          ordered = sortMainProductsByPairAvailability(ordered, data.products.secondaryAddon);
        }
        if (state.mode === "set" && data.config.setEnabled && data.products.primaryAddon && data.products.primaryAddon.length) {
          ordered = sortMainProductsByPairAvailability(ordered, data.products.primaryAddon);
        }
        return ordered;
      }

      return sortByPairSequence(items, getSortedProducts("main"));
    }

    function getMatchingPrimaryProduct() {
      return findMatchingPairProduct(getSelectedProduct("main"), data.products.primaryAddon);
    }

    function getMatchingSecondaryProduct() {
      return findMatchingPairProduct(getSelectedProduct("main"), data.products.secondaryAddon);
    }

    function selectMatchingPrimaryForMain() {
      var matchingPrimary = getMatchingPrimaryProduct() || getSortedProducts("primary")[0] || data.products.primaryAddon[0] || null;

      if (!matchingPrimary) {
        state.selectedPrimaryProductId = null;
        state.selectedPrimaryVariantId = null;
        return false;
      }

      state.selectedPrimaryProductId = matchingPrimary.id;
      state.selectedPrimaryVariantId = null;
      return true;
    }

    function selectMatchingSecondaryForMain() {
      var matchingSecondary = getMatchingSecondaryProduct() || getSortedProducts("secondary")[0] || data.products.secondaryAddon[0] || null;

      if (!matchingSecondary) {
        state.selectedSecondaryProductId = null;
        state.selectedSecondaryVariantId = null;
        return false;
      }

      state.selectedSecondaryProductId = matchingSecondary.id;
      state.selectedSecondaryVariantId = null;
      return true;
    }

    function getMainVariantQuantityMap() {
      return state.selectedMainVariantQuantities || {};
    }

    function getMainSelectedQuantityCount() {
      return Object.keys(getMainVariantQuantityMap()).reduce(function (total, variantId) {
        return total + Number(getMainVariantQuantityMap()[variantId] || 0);
      }, 0);
    }

    function getMainVariantSelectedCount(variantId) {
      return Number(getMainVariantQuantityMap()[String(variantId)] || 0);
    }

    function getMainProductSelectedCount(productId) {
      var product = byId(data.products.main, productId);

      if (!product) {
        return 0;
      }

      return product.variants.reduce(function (total, variant) {
        return total + getMainVariantSelectedCount(variant.id);
      }, 0);
    }

    function setMainVariantSelectedCount(variantId, count) {
      var next = {};

      Object.keys(getMainVariantQuantityMap()).forEach(function (key) {
        var value = Number(getMainVariantQuantityMap()[key] || 0);
        if (value > 0) {
          next[key] = value;
        }
      });

      if (count > 0) {
        next[String(variantId)] = count;
      } else {
        delete next[String(variantId)];
      }

      state.selectedMainVariantQuantities = next;
    }

    function clearMainVariantSelections() {
      state.selectedMainVariantQuantities = {};
      state.selectedMainVariantId = null;
    }

    function clearMainProductSelections(productId) {
      var product = byId(data.products.main, productId);

      if (!product) {
        return;
      }

      product.variants.forEach(function (variant) {
        setMainVariantSelectedCount(variant.id, 0);
      });

      var selectedEntries = getMainSelectedVariantsWithQuantities();
      state.selectedMainVariantId = selectedEntries.length ? selectedEntries[0].variant.id : null;
    }

    function findMainVariantAcrossProducts(variantId) {
      for (var i = 0; i < data.products.main.length; i += 1) {
        var product = data.products.main[i];
        var variant = getVariant(product, variantId);

        if (variant) {
          return variant;
        }
      }

      return null;
    }

    function getMainSelectedVariantsWithQuantities() {
      return Object.keys(getMainVariantQuantityMap()).map(function (variantId) {
        var count = Number(getMainVariantQuantityMap()[variantId] || 0);
        var variant = findMainVariantAcrossProducts(variantId);

        if (!variant || count <= 0) {
          return null;
        }

        return {
          variant: variant,
          quantity: count
        };
      }).filter(Boolean);
    }

    function getSelectedCount() {
      if (state.mode === "set") {
        var count = 0;
        if (getSelectedVariant("main")) {
          count += 1;
        }
        if (getSelectedVariant("primary")) {
          count += 1;
        }
        if (getSelectedVariant("secondary")) {
          count += 1;
        }
        return count;
      }

      if (Number((getTier() || {}).qty || 1) > 1) {
        return getMainSelectedQuantityCount();
      }

      return getSelectedVariant("main") ? 1 : 0;
    }

    function getRequiredCount() {
      if (state.mode === "set") {
        return 2;
      }

      return Number((getTier() || {}).qty || 1);
    }

    function hasSecondaryAddonProducts() {
      return !!(data.config.secondaryAddonEnabled && data.products.secondaryAddon && data.products.secondaryAddon.length > 0);
    }

    function createSetModeBundlePriceMeta(secondaryProduct, secondaryVariant) {
      var tier = getTier();
      var quantity = tier ? Number(tier.qty || 1) : 1;
      var setDiscountPerPiece = getSetDiscountPerPiece(quantity);
      var mainVariant = getPreviewVariant("main");
      var primaryVariant = getSelectedVariant("primary") || getPreviewVariant("primary");
      var entries = [];
      var totalEligibleQuantity = 0;

      if (mainVariant) {
        totalEligibleQuantity += quantity;
        entries.push({
          variant: mainVariant,
          quantity: quantity,
          discountPerPiece: setDiscountPerPiece
        });
      }

      if (primaryVariant) {
        totalEligibleQuantity += quantity;
        entries.push({
          variant: primaryVariant,
          quantity: quantity,
          discountPerPiece: setDiscountPerPiece
        });
      }

      if (secondaryVariant) {
        totalEligibleQuantity += quantity;
        entries.push({
          variant: secondaryVariant,
          quantity: quantity,
          discountPerPiece: getProductCrossDiscountPerPiece(secondaryProduct, totalEligibleQuantity)
        });
      }

      return createPriceMetaFromRoleEntries(entries, data);
    }

    function createQuantityModeBundlePriceMeta(secondaryProduct, secondaryVariant) {
      var tier = getTier();
      var quantity = tier ? Number(tier.qty || 1) : 1;
      var quantityDiscountPerPiece = getQuantityDiscountPerPiece(tier);
      var quantityEntries = [];
      var selectedMainCountForDiscount = quantity;
      var selectedEntries;
      var totalEligibleQuantity;
      var crossDiscountPerPiece;
      var mainDiscountPerPiece;

      if (quantity > 1) {
        selectedEntries = getMainSelectedVariantsWithQuantities();

        if (selectedEntries.length) {
          selectedMainCountForDiscount = selectedEntries.reduce(function (total, entry) {
            return total + Number(entry.quantity || 0);
          }, 0);

          totalEligibleQuantity = selectedMainCountForDiscount + (secondaryVariant ? 1 : 0);
          crossDiscountPerPiece = secondaryVariant ? getCurrentGroupCrossDiscountPerPiece(totalEligibleQuantity) : 0;
          mainDiscountPerPiece = Math.max(quantityDiscountPerPiece, crossDiscountPerPiece);

          selectedEntries.forEach(function (entry) {
            quantityEntries.push({
              variant: entry.variant,
              quantity: entry.quantity,
              discountPerPiece: mainDiscountPerPiece
            });
          });
        } else {
          totalEligibleQuantity = quantity + (secondaryVariant ? 1 : 0);
          crossDiscountPerPiece = secondaryVariant ? getCurrentGroupCrossDiscountPerPiece(totalEligibleQuantity) : 0;
          mainDiscountPerPiece = Math.max(quantityDiscountPerPiece, crossDiscountPerPiece);
          quantityEntries.push({
            variant: getPreviewVariant("main"),
            quantity: quantity,
            discountPerPiece: mainDiscountPerPiece
          });
        }
      } else {
        totalEligibleQuantity = quantity + (secondaryVariant ? 1 : 0);
        crossDiscountPerPiece = secondaryVariant ? getCurrentGroupCrossDiscountPerPiece(totalEligibleQuantity) : 0;
        mainDiscountPerPiece = Math.max(quantityDiscountPerPiece, crossDiscountPerPiece);
        quantityEntries.push({
          variant: getPreviewVariant("main"),
          quantity: quantity,
          discountPerPiece: mainDiscountPerPiece
        });
      }

      if (secondaryVariant) {
        quantityEntries.push({
          variant: secondaryVariant,
          quantity: 1,
          discountPerPiece: getProductCrossDiscountPerPiece(secondaryProduct, selectedMainCountForDiscount + 1)
        });
      }

      return createPriceMetaFromRoleEntries(quantityEntries, data);
    }

    function getBundlePriceMeta() {
      if (state.mode === "set") {
        return createSetModeBundlePriceMeta(getSelectedProduct("secondary"), getSelectedVariant("secondary"));
      }

      return createQuantityModeBundlePriceMeta(getSelectedProduct("secondary"), getSelectedVariant("secondary"));
    }

    function getQuantityTierDisplayMeta(tier) {
      var quantity = Number(tier && tier.qty || 1);
      var discountPerPiece = getQuantityDiscountPerPiece(tier);

      if (quantity > 1) {
        var selectedEntries = getMainSelectedVariantsWithQuantities();
        var selectedCount = selectedEntries.reduce(function (total, entry) {
          return total + Number(entry.quantity || 0);
        }, 0);

        if (selectedEntries.length && selectedCount >= quantity) {
	          return createPriceMetaFromEntries(selectedEntries, discountPerPiece, data);
        }
      }

	      return createPriceMeta([getPreviewVariant("main")], quantity, discountPerPiece, data);
    }

    function renderQuantityCards() {
      var variant = getPreviewVariant("main");
      var html = "";

      data.config.quantityTiers.forEach(function (tier) {
        var discountPerPiece = getQuantityDiscountPerPiece(tier);
	        var meta = createPriceMeta([variant], Number(tier.qty || 1), discountPerPiece, data);
	        var isActive = state.mode === "quantity" && state.tierId === tier.id;
	        var piecePrice = getDiscountedUnitPrice(variant, discountPerPiece, data);

        html += '<button type="button" class="bundle-configurator__option-card bundle-configurator__option-card--quantity' + (isActive ? ' is-active' : '') + '" data-tier-id="' + tier.id + '">';

        if (tier.badge) {
          html += '<span class="bundle-configurator__card-badge">' + tier.badge + '</span>';
        }

        html += '<span class="bundle-configurator__card-title">' + tier.label + '</span>';
        html += '<span class="bundle-configurator__card-price">' + money(piecePrice, data) + ' / pc</span>';

        if (meta.compareTotal > 0) {
          html += '<span class="bundle-configurator__card-compare">' + money(meta.total, data) + ' <span>' + money(meta.compareTotal, data) + '</span></span>';
          html += '<span class="bundle-configurator__save-badge">SAVE ' + money(meta.saving, data) + '</span>';
        }

        html += '</button>';
      });

      selectors.quantityGrid.innerHTML = html;

      selectors.quantityGrid.querySelectorAll("[data-tier-id]").forEach(function (button) {
        button.addEventListener("click", function () {
          state.mode = "quantity";
          state.tierId = button.getAttribute("data-tier-id");
          clearMainVariantSelections();
          state.secondaryAddonExpanded = false;
          state.selectedSecondaryProductId = null;
          state.selectedSecondaryVariantId = null;
          render();
        });
      });
    }

    function renderSetCard() {
      var matchingPrimary = getMatchingPrimaryProduct() || getSortedProducts("primary")[0] || data.products.primaryAddon[0] || null;

      if (!data.config.setEnabled || !data.products.primaryAddon || !data.products.primaryAddon.length) {
        if (state.mode === "set") {
          state.mode = "quantity";
          state.selectedPrimaryProductId = null;
          state.selectedPrimaryVariantId = null;
        }
        selectors.setArea.innerHTML = "";
        return;
      }

      var tier = getTier();
      var setDiscountPerPiece = getSetDiscountPerPiece(Number(tier.qty || 1));
      var previewPrimary = getPreviewVariant("primary") || getDefaultVariant(matchingPrimary);
      var previewMain = getPreviewVariant("main");
      var previewSecondary = getSelectedVariant("secondary");
      var variants = [previewMain, previewPrimary].filter(Boolean);
      var selectedRoleCount = getSelectedCount();
      var entries = variants.map(function (variant) {
        return {
          variant: variant,
          quantity: Number(tier.qty || 1),
          discountPerPiece: setDiscountPerPiece
        };
      });

      if (previewSecondary) {
        variants.push(previewSecondary);
        entries.push({
          variant: previewSecondary,
          quantity: Number(tier.qty || 1),
          discountPerPiece: getCrossAddonDiscountPerPiece(selectedRoleCount || 2)
        });
      }

      var meta = createPriceMetaFromRoleEntries(entries, data);
      var pieceCount = variants.length || 1;
      var averagePrice = pieceCount ? Math.round(meta.total / Number(tier.qty || 1) / pieceCount) : 0;
      var activeClass = state.mode === "set" ? " is-active" : "";
      var badgeMarkup = data.config.setBadge ? '<span class="bundle-configurator__card-badge">' + data.config.setBadge + "</span>" : "";
      var compareMarkup = meta.compareTotal > 0 ? '<span class="bundle-configurator__save-badge">SAVE ' + money(meta.saving, data) + "</span>" : "";

      selectors.setArea.innerHTML =
        '<p class="bundle-configurator__set-label">Or get the set &amp; save</p>' +
        '<button type="button" class="bundle-configurator__set-card' + activeClass + '" data-bundle-set-toggle>' +
          badgeMarkup +
          '<span class="bundle-configurator__set-main">' +
            '<span class="bundle-configurator__set-title">' + (data.config.setLabel || "") + '</span>' +
          '</span>' +
          '<span class="bundle-configurator__set-side">' +
            '<span class="bundle-configurator__set-price">' + money(averagePrice, data) + ' / pc</span>' +
          '</span>' +
          compareMarkup +
        "</button>";

      selectors.setArea.querySelector("[data-bundle-set-toggle]").addEventListener("click", function () {
        state.mode = "set";
        state.secondaryAddonExpanded = false;
        state.selectedSecondaryProductId = null;
        state.selectedSecondaryVariantId = null;
        var singleTier = getSingleQuantityTier();

        if (singleTier) {
          state.tierId = singleTier.id;
        }

        selectMatchingPrimaryForMain();

        render();
      });
    }

    function renderSelector(role, target) {
      var items = getSortedProducts(role);
      var selectedProduct = getSelectedProduct(role);
      var previousIcon = '<svg class="bundle-configurator__selector-arrow-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5L8 12l7 7"></path></svg>';
      var nextIcon = '<svg class="bundle-configurator__selector-arrow-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"></path></svg>';
      var html = '<button type="button" class="bundle-configurator__selector-arrow bundle-configurator__selector-arrow--prev is-visually-hidden" data-bundle-selector-prev aria-label="Previous products">' + previousIcon + '</button>' +
        '<div class="bundle-configurator__selector-row">';

      items.forEach(function (product) {
        var selectedProductMatch = selectedProduct && String(selectedProduct.id) === String(product.id);
        var selectedVariant = getSelectedVariant(role);
        var completedSelection = false;
        var selectedCountForProduct = role === "main" ? getMainProductSelectedCount(product.id) : 0;

        if (role === "main" && state.mode === "quantity" && Number((getTier() || {}).qty || 1) > 1) {
          completedSelection = selectedCountForProduct > 0;
        } else {
          completedSelection = selectedProductMatch && selectedVariant && String(selectedVariant.id) !== "";
        }

        var selectedClass = (selectedProductMatch || selectedCountForProduct > 0) ? " is-active" : "";

        html += '<button type="button" class="bundle-configurator__product-card' + selectedClass + '" data-role="' + role + '" data-product-id="' + product.id + '">';
        if (completedSelection) {
          html += '<span class="bundle-configurator__product-check" aria-hidden="true"></span>';
        }
        html += '<span class="bundle-configurator__product-image">';
        var imageUrl = normalizeImageUrl(product.featuredImage);
        if (imageUrl) {
          html += '<img src="' + imageUrl + '" alt="' + product.title.replace(/"/g, "&quot;") + '" loading="lazy">';
        }
        html += "</span>";
        html += '<span class="bundle-configurator__product-label">' + product.label + "</span>";
        if (selectedCountForProduct > 0) {
          html += '<span class="bundle-configurator__product-state">×' + selectedCountForProduct + "</span>";
        }
        html += "</button>";
      });

      html += "</div>" +
        '<button type="button" class="bundle-configurator__selector-arrow bundle-configurator__selector-arrow--next is-visually-hidden" data-bundle-selector-next aria-label="Next products">' + nextIcon + '</button>';
      target.innerHTML = html;
      enhanceHorizontalScroll(target.querySelector(".bundle-configurator__selector-row"));

      target.querySelectorAll("[data-product-id]").forEach(function (button) {
        button.addEventListener("click", function () {
          var productId = button.getAttribute("data-product-id");

          if (role === "main") {
            state.selectedMainProductId = productId;

            if (state.mode === "set") {
              selectMatchingPrimaryForMain();
              state.secondaryAddonExpanded = false;
              state.selectedSecondaryProductId = null;
              state.selectedSecondaryVariantId = null;
            } else if (!(state.mode === "quantity" && Number((getTier() || {}).qty || 1) > 1)) {
              clearMainVariantSelections();
              state.selectedPrimaryProductId = null;
              state.selectedPrimaryVariantId = null;
              state.secondaryAddonExpanded = false;
              state.selectedSecondaryProductId = null;
              state.selectedSecondaryVariantId = null;
            }
          } else if (role === "primary") {
            state.selectedPrimaryProductId = productId;
            state.selectedPrimaryVariantId = null;
            state.secondaryAddonExpanded = false;
            state.selectedSecondaryProductId = null;
            state.selectedSecondaryVariantId = null;
          } else {
            state.selectedSecondaryProductId = productId;
            state.selectedSecondaryVariantId = null;
          }

          refreshAfterProductChange(role);
        });
      });
    }

    function getOptionalAddonLabel() {
      var label = String(data.config.secondaryAddonLabel || "Addon").trim();
      var secondaryText = (data.products.secondaryAddon || []).map(function (product) {
        return [product.title, product.label, product.handle].join(" ");
      }).join(" ").toLowerCase();

      if (secondaryText.indexOf("sweatpant") !== -1 || secondaryText.indexOf("sweatpants") !== -1) {
        return "Sweatpants";
      }

      if (secondaryText.indexOf("short") !== -1 || secondaryText.indexOf("shorts") !== -1) {
        return "Shorts";
      }

      if (secondaryText.indexOf("t-shirt") !== -1 || secondaryText.indexOf("tshirt") !== -1 || secondaryText.indexOf(" tee") !== -1) {
        return "Tee";
      }

      if (secondaryText.indexOf("hoodie") !== -1 || secondaryText.indexOf("hoodies") !== -1) {
        return "Hoodie";
      }

      label = label.replace(/^select\s+/i, "").trim();

      return label || "Addon";
    }

    function getOptionalAddonPriceMeta() {
      var product = getSelectedProduct("secondary") || getSortedProducts("secondary")[0] || data.products.secondaryAddon[0] || null;
      var variant = getSelectedVariant("secondary") || getDefaultVariant(product);
      var currentMeta;
      var projectedMeta;
      var moreAmount;
      var saving;

      if (!variant) {
        return null;
      }

      if (state.mode === "set") {
        currentMeta = createSetModeBundlePriceMeta(null, null);
        projectedMeta = createSetModeBundlePriceMeta(product, variant);
      } else {
        currentMeta = createQuantityModeBundlePriceMeta(null, null);
        projectedMeta = createQuantityModeBundlePriceMeta(product, variant);
      }

      moreAmount = Math.max(0, Number(projectedMeta.total || 0) - Number(currentMeta.total || 0));
      saving = Math.max(0, Number(variant.price || 0) - moreAmount);

      return {
        price: moreAmount,
        saving: saving
      };
    }

    function getOptionalAddonSubtitle() {
      var priceMeta = getOptionalAddonPriceMeta();

      if (!priceMeta) {
        return "";
      }

      if (priceMeta.saving > 0) {
        return "Add it for " + money(priceMeta.price, data) + " more &middot; save " + money(priceMeta.saving, data);
      }

      return "Add it for " + money(priceMeta.price, data) + " more";
    }

    function expandSecondaryAddon() {
      var selectedSecondary = getSelectedProduct("secondary");

      state.secondaryAddonExpanded = true;

      if (!selectedSecondary) {
        selectMatchingSecondaryForMain();
      }

      render();
    }

    function collapseSecondaryAddon() {
      state.secondaryAddonExpanded = false;
      state.selectedSecondaryProductId = null;
      state.selectedSecondaryVariantId = null;

      render();
    }

    function renderSecondaryOptionalPrompt() {
      var subtitle = getOptionalAddonSubtitle();

      selectors.secondarySelector.innerHTML =
        '<button type="button" class="bundle-configurator__optional-card" data-bundle-secondary-expand>' +
          '<span class="bundle-configurator__optional-icon" aria-hidden="true">+</span>' +
          '<span class="bundle-configurator__optional-copy">' +
            '<span class="bundle-configurator__optional-heading">' +
              '<span class="bundle-configurator__optional-title">' + getOptionalAddonLabel() + '</span>' +
              '<span class="bundle-configurator__optional-pill">OPTIONAL</span>' +
            '</span>' +
            (subtitle ? '<span class="bundle-configurator__optional-subtitle">' + subtitle + '</span>' : '') +
          '</span>' +
          '<span class="bundle-configurator__optional-chevron" aria-hidden="true"></span>' +
        '</button>';
      selectors.secondarySizes.innerHTML = "";

      var expandButton = selectors.secondarySelector.querySelector("[data-bundle-secondary-expand]");
      if (expandButton) {
        expandButton.addEventListener("click", function () {
          expandSecondaryAddon();
        });
      }
    }

    function renderSecondaryAddon() {
      if (!data.config.secondaryAddonEnabled || !data.products.secondaryAddon || !data.products.secondaryAddon.length) {
        selectors.secondarySelector.innerHTML = "";
        selectors.secondarySizes.innerHTML = "";
        return;
      }

      if (!state.secondaryAddonExpanded) {
        renderSecondaryOptionalPrompt();
        return;
      }

      renderSelector("secondary", selectors.secondarySelector);
      renderSizes("secondary", selectors.secondarySizes);
    }

    function getSelectorTarget(role) {
      if (role === "main") {
        return selectors.mainSelector;
      }

      if (role === "primary") {
        return selectors.primarySelector;
      }

      return selectors.secondarySelector;
    }

    function refreshProductCardState(role) {
      var target = getSelectorTarget(role);
      var selectedProduct = getSelectedProduct(role);

      if (!target) {
        return;
      }

      target.querySelectorAll("[data-product-id]").forEach(function (button) {
        var productId = button.getAttribute("data-product-id");
        var selectedProductMatch = selectedProduct && String(selectedProduct.id) === String(productId);
        var selectedVariant = getSelectedVariant(role);
        var selectedCountForProduct = role === "main" ? getMainProductSelectedCount(productId) : 0;
        var isMultiMainQuantity = role === "main" && state.mode === "quantity" && Number((getTier() || {}).qty || 1) > 1;
        var completedSelection = isMultiMainQuantity ? selectedCountForProduct > 0 : selectedProductMatch && selectedVariant && String(selectedVariant.id) !== "";
        var check = button.querySelector(".bundle-configurator__product-check");
        var stateLabel = button.querySelector(".bundle-configurator__product-state");

        button.classList.toggle("is-active", !!(selectedProductMatch || selectedCountForProduct > 0));

        if (completedSelection && !check) {
          button.insertAdjacentHTML("afterbegin", '<span class="bundle-configurator__product-check" aria-hidden="true"></span>');
        } else if (!completedSelection && check) {
          check.remove();
        }

        if (selectedCountForProduct > 0) {
          if (stateLabel) {
            stateLabel.textContent = "×" + selectedCountForProduct;
          } else {
            button.insertAdjacentHTML("beforeend", '<span class="bundle-configurator__product-state">×' + selectedCountForProduct + "</span>");
          }
        } else if (stateLabel) {
          stateLabel.remove();
        }
      });
    }

    function refreshAfterSizeChange(role, sizeTarget) {
      renderQuantityCards();
      renderSetCard();
      renderSizes(role, sizeTarget);
      refreshProductCardState(role);
      updateStepMeta();
      updateUpsell();
      updateSubmit();
    }

    function refreshSelectorOrder(role, target) {
      var cards = target.querySelectorAll("[data-product-id]");
      var items = getSortedProducts(role);
      if (cards.length !== items.length || items.some(function (product, index) {
        return String(product.id) !== cards[index].getAttribute("data-product-id");
      })) {
        renderSelector(role, target);
      }
    }

    function refreshAfterProductChange(role) {
      renderQuantityCards();
      renderSetCard();

      if (role === "main") {
        refreshSelectorOrder("main", selectors.mainSelector);
        renderSizes("main", selectors.mainSizes);
        refreshProductCardState("main");

        if (state.mode === "set") {
          renderSelector("primary", selectors.primarySelector);
          renderSizes("primary", selectors.primarySizes);
          refreshProductCardState("primary");

          renderSecondaryAddon();
        }

        if (state.mode !== "set") {
          renderSecondaryAddon();
        }
      } else if (role === "primary") {
        refreshSelectorOrder("main", selectors.mainSelector);
        refreshSelectorOrder("primary", selectors.primarySelector);
        renderSizes("primary", selectors.primarySizes);
        refreshProductCardState("primary");
        renderSecondaryAddon();
      } else {
        renderSizes("secondary", selectors.secondarySizes);
        refreshProductCardState("secondary");
      }

      updateSectionsVisibility();
      updateStepMeta();
      updateUpsell();
      updateSubmit();
    }

    function renderSizes(role, target) {
      var product = getSelectedProduct(role);

      if (!product) {
        target.innerHTML = "";
        return;
      }

      var optionIndex = getSizeOptionIndex(product);
      var optionName = product.options[optionIndex] || "Size";
      var selectedVariant = getSelectedVariant(role);
      var sizeValues = getSizeValues(product);
      var title = "Select " + optionName.toLowerCase() + " · " + product.label;
      var isMultiMainQuantity = role === "main" && state.mode === "quantity" && Number((getTier() || {}).qty || 1) > 1;
      var hasFastDispatchOption = sizeValues.some(function (size) {
        var variantForSize = getVariantForSize(product, optionIndex, size.value);
        return hasFastDispatch(variantForSize);
      }) || hasFastDispatch(selectedVariant) || productHasFastDispatch(product);
      var html = '<div class="bundle-configurator__size-panel"><div class="bundle-configurator__size-header"><div class="bundle-configurator__size-title">' + title + '</div><button type="button" class="bundle-configurator__size-clear" data-role-clear="' + role + '">×</button></div>';

      if (hasFastDispatchOption) {
        html += '<div class="bundle-configurator__size-note-row">' + renderFastDispatchIndicator("Binnen 24 uur verzonden") + "</div>";
      }

      html += '<div class="bundle-configurator__size-grid">';

      sizeValues.forEach(function (size) {
        var variant = getVariantForSize(product, optionIndex, size.value);
        var selectedCount = isMultiMainQuantity && variant ? getMainVariantSelectedCount(variant.id) : 0;
        var isActive = isMultiMainQuantity ? selectedCount > 0 : selectedVariant && selectedVariant.options[optionIndex] === size.value;
        var activeClass = isActive ? " is-active" : "";
        var disabledAttr = size.available ? "" : " disabled";
        var disabledClass = size.available ? "" : " is-disabled";

        html += '<button type="button" class="bundle-configurator__size-button' + activeClass + disabledClass + '" data-role-size="' + role + '" data-size-value="' + size.value.replace(/"/g, "&quot;") + '"' + disabledAttr + ">";
        if (selectedCount > 0) {
          html += '<span class="bundle-configurator__size-count" aria-hidden="true">' + selectedCount + "</span>";
        }
        html += '<span class="bundle-configurator__size-button-copy">';
        html += '<span class="bundle-configurator__size-value">' + size.value + "</span>";
        if (hasFastDispatch(variant)) {
          html += renderFastDispatchIndicator("24H");
        }
        html += "</span>";
        html += "</button>";

        if (!selectedVariant && variant && size.available && product.variants.length === 1) {
          if (role === "main") {
            state.selectedMainVariantId = variant.id;
          } else if (role === "primary") {
            state.selectedPrimaryVariantId = variant.id;
          } else {
            state.selectedSecondaryVariantId = variant.id;
          }
        }
      });

      html += "</div></div>";
      target.innerHTML = html;

      target.querySelectorAll("[data-role-size]").forEach(function (button) {
        button.addEventListener("click", function () {
          var selectedSize = button.getAttribute("data-size-value");
          var variant = getVariantForSize(product, optionIndex, selectedSize);

          if (!variant) {
            return;
          }

          if (role === "main") {
            if (isMultiMainQuantity) {
              var totalSelected = getMainSelectedQuantityCount();
              var currentCount = getMainVariantSelectedCount(variant.id);
              var tierQuantity = Number((getTier() || {}).qty || 1);

              if (currentCount > 0) {
                setMainVariantSelectedCount(variant.id, currentCount - 1);
              } else if (totalSelected < tierQuantity) {
                setMainVariantSelectedCount(variant.id, 1);
              }

              var selectedEntries = getMainSelectedVariantsWithQuantities();
              state.selectedMainVariantId = selectedEntries.length ? selectedEntries[0].variant.id : null;
            } else {
              state.selectedMainVariantId = variant.id;
            }
          } else if (role === "primary") {
            state.selectedPrimaryVariantId = variant.id;
          } else {
            state.selectedSecondaryVariantId = variant.id;
          }

          refreshAfterSizeChange(role, target);
        });
      });

      var clearButton = target.querySelector("[data-role-clear]");
      if (clearButton) {
        clearButton.addEventListener("click", function () {
          if (role === "main") {
            if (isMultiMainQuantity) {
              clearMainProductSelections(product.id);
            } else {
              state.selectedMainVariantId = null;
            }
          } else if (role === "primary") {
            state.selectedPrimaryVariantId = null;
          } else {
            state.selectedSecondaryVariantId = null;
            collapseSecondaryAddon();
            return;
          }

          refreshAfterSizeChange(role, target);
        });
      }
    }

    function updateSubmit() {
      var selectedCount = getSelectedCount();
      var requiredCount = getRequiredCount();
      var secondaryVariant = getSelectedVariant("secondary");
      var mainReady = state.mode === "quantity" && Number((getTier() || {}).qty || 1) > 1
        ? getMainSelectedQuantityCount() >= requiredCount
        : !!getSelectedVariant("main");
      var primaryReady = state.mode !== "set" || !!getSelectedVariant("primary");
      var secondaryReady = !state.secondaryAddonExpanded || !!secondaryVariant;
      if (state.mode !== "set" && secondaryVariant) selectedCount += 1;
      if (state.secondaryAddonExpanded || secondaryVariant) requiredCount += 1;
      var meta = getBundlePriceMeta();
      var enabled = mainReady && primaryReady && secondaryReady && !state.loading;
      var unitLabel = selectedCount === 1 && requiredCount === 1 ? "pc" : "pcs";

      selectors.submit.disabled = !enabled;
      selectors.submit.classList.toggle("is-loading", state.loading);
      selectors.submit.textContent = "Choose " + selectedCount + "/" + requiredCount + " " + unitLabel + " · " + money(meta.total, data);
    }

    function updateUpsell() {
      if (!selectors.upsell) {
        return;
      }

      if (state.mode === "set") {
        selectors.upsell.innerHTML = "";
        selectors.upsell.classList.add("hidden");
        return;
      }

      if (getSelectedCount() < 1) {
        selectors.upsell.innerHTML = "";
        selectors.upsell.classList.add("hidden");
        return;
      }

      var tier = getTier();
      var quantity = Number(tier && tier.qty || 1);
      var nextQuantity = quantity === 1 ? 2 : quantity === 2 ? 3 : 0;
      var nextTier = nextQuantity ? getTierByQuantity(nextQuantity) : null;

      if (!nextTier) {
        selectors.upsell.innerHTML = "";
        selectors.upsell.classList.add("hidden");
        return;
      }

      var currentMeta = getQuantityTierDisplayMeta(tier);
      var nextMeta = getQuantityTierDisplayMeta(nextTier);
      var moreAmount = Math.max(0, Number(nextMeta.total || 0) - Number(currentMeta.total || 0));
      var productName = data.config.mainLabel || "Product";
      var actionLabel = quantity === 1 ? "Add a second " : "Add a third ";

      selectors.upsell.innerHTML =
        '<button type="button" class="bundle-configurator__upsell-button" data-bundle-upsell-target="' + nextTier.id + '">' +
          '<span class="bundle-configurator__upsell-icon" aria-hidden="true">+</span>' +
          '<span class="bundle-configurator__upsell-text">' + actionLabel + productName + ', just ' + money(moreAmount, data) + ' more</span>' +
        "</button>";
      selectors.upsell.classList.remove("hidden");

      var upsellButton = selectors.upsell.querySelector("[data-bundle-upsell-target]");
      if (upsellButton) {
        upsellButton.addEventListener("click", function () {
          state.mode = "quantity";
          state.tierId = upsellButton.getAttribute("data-bundle-upsell-target");
          clearMainVariantSelections();
          render();
        });
      }
    }

    function updateStepMeta() {
      if (selectors.mainMeta) {
        if (state.mode === "quantity" && Number((getTier() || {}).qty || 1) > 1) {
          selectors.mainMeta.textContent = "CHOOSE " + Math.max(Number((getTier() || {}).qty || 1) - getMainSelectedQuantityCount(), 0) + " PCS";
        } else {
          selectors.mainMeta.textContent = getSelectedVariant("main") ? "SELECTED" : "CHOOSE 1 PCS";
        }
      }

      if (selectors.primaryMeta) {
        selectors.primaryMeta.textContent = getSelectedVariant("primary") ? "SELECTED" : "CHOOSE 1 PCS";
      }

      if (selectors.secondaryMeta) {
        selectors.secondaryMeta.textContent = getSelectedVariant("secondary") ? "SELECTED" : "OPTIONAL";
      }
    }

    function updateSectionsVisibility() {
      var showSetSections = state.mode === "set";
      var showSecondary = hasSecondaryAddonProducts();

      selectors.primarySection.classList.toggle("hidden", !showSetSections);
      selectors.secondarySection.classList.toggle("hidden", !showSecondary);
      selectors.secondarySection.classList.toggle("is-optional-collapsed", showSecondary && !state.secondaryAddonExpanded);
    }

    function buildItems() {
      var tier = getTier();
      var quantity = Number(tier ? tier.qty || 1 : 1);
      var group = "bundle-" + Date.now() + "-" + Math.round(Math.random() * 100000);
      var mode = "single";

      if (state.mode === "set") {
        mode = "set";
      } else if (quantity > 1) {
        mode = "multi";
      }

      if (state.mode === "quantity" && quantity > 1) {
        var multiItems = getMainSelectedVariantsWithQuantities().map(function (entry) {
          return {
            id: entry.variant.id,
            quantity: entry.quantity,
            properties: {
              _bundle_key: data.config.bundleKey || "",
              _bundle_mode: mode,
              _bundle_qty: quantity,
              _bundle_role: "main",
              _bundle_group: group
            }
          };
        });
        var multiSecondaryVariant = getSelectedVariant("secondary");

        if (multiSecondaryVariant) {
          multiItems.push({
            id: multiSecondaryVariant.id,
            quantity: 1,
            properties: {
              _bundle_key: data.config.bundleKey || "",
              _bundle_mode: mode,
              _bundle_qty: quantity,
              _bundle_role: "secondary_addon",
              _bundle_group: group
            }
          });
        }

        return multiItems;
      }

      var mainVariant = getSelectedVariant("main");
      var secondaryVariant = getSelectedVariant("secondary");
      var items = [];

      if (mainVariant) {
        items.push({
          id: mainVariant.id,
          quantity: quantity,
          properties: {
            _bundle_key: data.config.bundleKey || "",
            _bundle_mode: mode,
            _bundle_qty: quantity,
            _bundle_role: "main",
            _bundle_group: group
          }
        });
      }

      if (state.mode === "set") {
        var primaryVariant = getSelectedVariant("primary");

        if (primaryVariant) {
          items.push({
            id: primaryVariant.id,
            quantity: quantity,
            properties: {
              _bundle_key: data.config.bundleKey || "",
              _bundle_mode: mode,
              _bundle_qty: quantity,
              _bundle_role: "primary_addon",
              _bundle_group: group
            }
          });
        }
      }

      if (secondaryVariant) {
        items.push({
          id: secondaryVariant.id,
          quantity: state.mode === "set" ? quantity : 1,
          properties: {
            _bundle_key: data.config.bundleKey || "",
            _bundle_mode: mode,
            _bundle_qty: quantity,
            _bundle_role: "secondary_addon",
            _bundle_group: group
          }
        });
      }

      return items;
    }

    function showSuccessState(response) {
      if (typeof window.ajaxCart !== "undefined" && window.ajaxCart) {
        if (window.general && window.general.enable_cart_drawer) {
          window.ajaxCart.load(false, true, false, true);
        } else {
          window.ajaxCart.fetchCartCount();
        }
        return;
      }

      if (typeof window.updateCartPanel === "function") {
        window.updateCartPanel(response);
        if (window.general && window.general.template === "cart" && typeof window.updateCartPage === "function") {
          window.updateCartPage(response);
        }
        return;
      }

      window.location.href = window.routes.cart_url;
    }

    function showError(message) {
      state.loading = false;
      updateSubmit();

      if (message && typeof window.CustomEvent === "function") {
        window.dispatchEvent(new CustomEvent("showAlert", {
          detail: {
            message: message,
            type: "error"
          }
        }));
        return;
      }

      alert(message || "Unable to add bundle to cart.");
    }

    function submitBundle() {
      if (selectors.submit.disabled || state.loading) {
        return;
      }

      state.loading = true;
      updateSubmit();

      fetch(window.routes.cart_add_url, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/javascript",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({
          items: buildItems(),
          sections: "side-cart"
        })
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          state.loading = false;
          updateSubmit();

          if (response.status) {
            if (typeof response.description === "object") {
              Object.keys(response.description).forEach(function (key) {
                showError(response.description[key]);
              });
            } else {
              showError(response.description || response.message);
            }
            return;
          }

          showSuccessState(response);
        })
        .catch(function (error) {
          state.loading = false;
          updateSubmit();
          console.error("bundle-configurator add error", error);
          showError("Unable to add bundle to cart.");
        });
    }

    function render() {
      renderQuantityCards();
      renderSetCard();
      renderSelector("main", selectors.mainSelector);
      renderSizes("main", selectors.mainSizes);

      if (state.mode === "set") {
        renderSelector("primary", selectors.primarySelector);
        renderSizes("primary", selectors.primarySizes);
      } else {
        selectors.primarySelector.innerHTML = "";
        selectors.primarySizes.innerHTML = "";
      }

      renderSecondaryAddon();
      updateSectionsVisibility();
      updateStepMeta();
      updateUpsell();
      updateSubmit();
    }

    selectors.submit.addEventListener("click", submitBundle);
    render();
  }

  function initializeConfigurators(scope) {
    (scope || document).querySelectorAll("[data-bundle-configurator]").forEach(initConfigurator);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeConfigurators(document);
    });
  } else {
    initializeConfigurators(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeConfigurators(event.target);
  });
}());
